import {AudioHandler} from "./handlers/AudioHandler";
import {JuvolyWS} from "./ws/JuvolyWS";
import {GoogleSpeechWS} from "./ws/GoogleSpeechWS";
import {WSErrorHandler, WSTranscriptHandler} from "./ws/ws";
import {WebmAudioHandler} from "./handlers/WebmAudioHandler";
import {Linear16AudioHandler} from "./handlers/Linear16AudioHandler";


export class AudioChannel {
    constructor(
        protected language: string,
        public transcriptHandler: WSTranscriptHandler,
        public errorHandler: WSErrorHandler,
        public handler: AudioHandler | null = null,
        protected baseAPIUrl: string = process.env.REACT_APP_BACKEND_WS_URL ?? "/api",
    ) {
    }

    async connect() {
        // This method connects to the WebSocket servers for audio transcription.
        // It first attempts to connect to the Juvoly WebSocket, and if that fails,
        // it falls back to the Google Speech WebSocket.

        const handlers = [
            new WebmAudioHandler(new JuvolyWS(this.language, this.errorHandler, this.transcriptHandler)),
            new Linear16AudioHandler(new GoogleSpeechWS(this.baseAPIUrl, this.errorHandler, this.transcriptHandler)),
            // and a fallback for the fallback (thanks Stijn for the idea)
            // If Juvoly fails and GoogleSpeech fails we try with Juvoly and GoogleSpeech one more time
            new WebmAudioHandler(new JuvolyWS(this.language, this.errorHandler, this.transcriptHandler)),
            new Linear16AudioHandler(new GoogleSpeechWS(this.baseAPIUrl, this.errorHandler, this.transcriptHandler)),
        ]

        for (this.handler of handlers) {
            try {
                console.info(`[AudioChannel] Connecting to ${this.handler.ws.name}`)
                await this.handler.ws.connect()

                console.info(`[AudioChannel] Connected to ${this.handler.ws.name}`)
                return this.handler.ws.name
            } catch (e) {
                console.error(e)
            }
        }
        throw new Error(`Failed to connect to any audio service.`)
    }

    public async stop() {
        await this.handler?.stop()
        console.info(`[AudioChannel] stopped`);
    }
}
